<!-- <div class="session-info" *ngIf="state"> -->
  <!-- Compact pill: always visible, minimal footprint. Click to expand. -->
  <!-- <button
    type="button"
    class="session-info__pill"
    [class.session-info__pill--warning]="state.phase === 'warning'"
    (click)="toggle()"
    [attr.title]="'Session info — expires in ' + formatTime(state.remainingSeconds)"
  >
    <span class="session-info__dot session-info__dot--{{ state.phase }}"></span>
    <span class="session-info__pill-label">Session</span>
    <span class="session-info__pill-time">{{ formatTime(state.remainingSeconds) }}</span>
    <span class="session-info__caret">{{ expanded ? '▴' : '▾' }}</span>
  </button> -->

  <!-- Expandable diagnostic panel. -->
  <!-- <div class="session-info__panel" *ngIf="expanded">
    <div class="session-info__row">
      <span>User</span><strong>{{ appService.loggedInUser?.name || '-' }}</strong>
    </div>
    <div class="session-info__row">
      <span>Role</span><strong>{{ appService.loggedInUser?.role || '-' }}</strong>
    </div>
    <div class="session-info__row">
      <span>Team</span><strong>{{ appService.loggedInUser?.team || '-' }}</strong>
    </div>
    <div class="session-info__row session-info__row--accent">
      <span>Expires in</span><strong>{{ formatTime(state.remainingSeconds) }}</strong>
    </div>
    <div class="session-info__row">
      <span>Session expires</span><strong>{{ (state.sessionExpiresAt | date: 'mediumTime') || '-' }}</strong>
    </div>
    <div class="session-info__row">
      <span>Status</span>
      <strong class="session-info__status session-info__status--{{ state.phase }}">
        {{ state.phase }}
      </strong>
    </div>
  </div>
</div> -->

<!-- Pre-expiry warning popup (shown shortly before the session expires). -->
<div class="session-warning__overlay" *ngIf="state && state.phase === 'warning'">
  <div class="session-warning__dialog" role="alertdialog" aria-modal="true">
    <div class="session-warning__header">
      <button
        type="button"
        class="session-warning__close-btn"
        (click)="stayLoggedIn()"
        title="Close"
        aria-label="Close warning"
      >
        ✕
      </button>
    </div>
    <div class="session-warning__title">Your session is about to expire</div>
    <div class="session-warning__body">
      Your session is about to expire in
      <strong class="session-warning__count">{{ formatTime(state.remainingSeconds) }}</strong> 
      due to inactivity.
      <br />
      Please click the button below to stay logged in.
    </div>
    <div class="session-warning__actions">
      <button type="button" class="session-warning__btn session-warning__btn--primary" (click)="stayLoggedIn()">
        Stay logged in
      </button>
      <!-- <button type="button" class="session-warning__btn session-warning__btn--secondary" (click)="logoutNow()">
        Log out now
      </button> -->
    </div>
  </div>
</div>

<!-- Session-expired popup (shown when the countdown reaches zero). -->
<div class="session-warning__overlay" *ngIf="state && state.phase === 'expired'">
  <div class="session-warning__dialog" role="alertdialog" aria-modal="true">
      <div class="session-warning__header">
      <!-- <button
        type="button"
        class="session-warning__close-btn"
        (click)="logoutNow()"
        title="Close"
        aria-label="Close warning"
      >
        ✕
      </button> -->
    </div>
    <!-- <div class="session-warning__title">Your session has expired</div> -->
    <div class="session-warning__body">
      Your session has expired due to inactivity.
      <br />
      Please click below to sign back in.
    </div>
    <div class="session-warning__actions">
      <button type="button" class="session-warning__btn session-warning__btn--primary" (click)="signBackIn()">
        Sign back in
      </button>
    </div>
  </div>
</div>
